import { Component, OnInit } from '@angular/core';
import { MailboxService } from '../mailbox-service/mailbox.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { MailboxEmailComponent } from '../mailbox-email/mailbox-email.component';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UIRouter, Transition } from "@uirouter/angular";
import { NgClass } from '@angular/common';
import { ProfileService } from '../profile-service/profile.service';
import { CustomerService } from '../customer-service/customer.service';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

const insurers = ['Direct Line', 'More Than', 'Admiral', 'Elephant'];


import swal from 'sweetalert2';

@Component({
  selector: 'app-mailbox',
  templateUrl: './mailbox.component.html',
  styleUrls: ['./mailbox.component.less']
})


export class MailboxComponent implements OnInit {
	
	private emails:Array<any>
  private emailForQuoteId
  private className: string
  private profile: string
  public customer

  emailToProduct: any = {}
  refreshClasses:string


  constructor(private mailboxService : MailboxService, 
              private sanitizer: DomSanitizer, 
              private router: UIRouter,
              private profileService: ProfileService,
              private customerService: CustomerService) {

    this.refreshClasses = 'refresh-button';

  }

  ngOnInit() {

    this.mailboxService.retrieveEmails()

    this.customerService.retrieveCustomer(this.router.globals.params.customerId);

    this.customerService.profile.subscribe((x)=>{

      this.customer = x

    })

  	//this.foo = this.introductionsService.foo
  	//this.emails = this.mailboxService.emails

    this.mailboxService.emails.subscribe((x)=>{
      this.emails = x

      if(this.emails.length > 0){
        
        //this.router.stateService.go('app.mailbox.email',{id:this.emails[0].id})
      }


    })

    this.mailboxService.mailboxClassName.subscribe((x)=>{
       this.className = x   
    })
   
  }


  refreshMailbox(){

    this.mailboxService.retrieveEmails();
    //Set the class string to include the spin class so the refresh icon rotates
    this.refreshClasses = 'refresh-button spin'

    setTimeout(() => {
      //Keep the spin added for 2 seconds, then remove the spin class so it stops
      this.refreshClasses = 'refresh-button'
    },2000);

  }

  markAsRead(id){
    this.mailboxService.emailId = id;
    this.mailboxService.markAsRead();
  }

   public model: any;

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => term.length < 2 ? []
        : insurers.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10));

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/mailbox/mailbox.component.ts